<template>
  <select v-model="selected"
	  :value="value"
	  :name="sel_name"
	  :style="sstyle"
	  @mouseover="infoUpdate"
	  @change="changed">
    <option v-for="o in opt"
	    :value="o.value"
	    :priceCode="o.priceCode"
	    :style="ostyle(o)">
      {{ o.text }} <!-- {{ o.message }} -->
      <!-- <template v-if="!o.message">{{ o.info }}</template> -->
      <!-- <template v-if="o.message && !o.message.startsWith('<<個別調達')">{{ o.info }}</template> -->
      <template v-if="o.message && !o.message.startsWith('<<個別調達')">{{ o.message }}</template>
      {{ o.info }} {{ o.price_diff }}
      <!-- {{ o.text }} {{ o.message }} {{ o.info }} {{ o.price_diff }} -->
    </option>
  </select>
</template>
<script>
const $ = require('jquery')
import store from '@/store'
//import priceCheckStore from '@/PriceCheckStore'

export default {
    name: 's-select',
    props: ['el','value','custom'],
    data() {
	return {
	    selected: '',
	    updated: false,
	    width: 1,
	    opt: [{
		value: '',
		priceCode: '',
		text: '',
		info: '',
		infoLevel: 0,
		message: '',
		//style: '',
		price_diff: '',
	    }]
	}
    },
    computed: {
	sel_name: function() {
	    //console.log(this.el.firstElementChild.getAttribute("name"))
	    return this.el.getAttribute("name")	    
	},
	is_chrome: function() {
	    let userAgent = window.navigator.userAgent.toLowerCase();
	    return (userAgent.indexOf("chrome") >= 0)
	},
	sstyle: function() {
	    return "width:"+((this.width+5)*2/3)+"em;"
	},
	//inc_N8104_184: function() {
	//    for(let o of this.opt) {
	//	const ncode = o.value.split(/\s+/)
	//	for(let n of ncode) {
	//	    if('N8104-184'==ncode) return true;
	//	}
	//    }
	//    return false
	//}
    },
    methods: {
	ostyle(o) {
	    if(o.infoLevel == 2)
		return "color: #FF0000;"
	    else if(o.message != '')
		return "color: brown;"
	    else if (o.infoLevel == 1)
		return "color: #FF8800;"
	    else
		return ""
	},
	infoUpdate() {
	    // test
	    //console.log("CartLocalSave:", CartLocalSave.available());
	    // console.log("CartLocalSave:", CartLocalSave.lavailable());
	    if(this.updated) return
	    
	    //if(!this.updated) {
		if(store.state.singleGetPrices) {
		    console.log("now processing...")
		    return
		}
		store.setSingleGetPrices(true)
		//event.preventDefault()
		/* for (let o of this.opt) {
		    o.price_diff = o.priceCode
		} */
		let key = this.sel_name
		let parameters = key+"="+this.selected
		for (let o of this.opt) {
		    parameters += "&"+key+"="+o.value
		    if('priceCode' in o)
			parameters += "&priceCode="+o.priceCode
		    else
			parameters += "&priceCode=NULL"
		}
		parameters += "&key="+key

		/*
		$.ajax({
		    url: '../Prices.action',
		    type: 'post',
		    async: false,
		    data: parameters,
		    success: (res) => {
			if(res.length < 1) {
			    store.setSingleGetPrices(false)
			    return
			}
			const price = res.split(" ");
			// ↓ 金額計算が中断された場合
			if(price.length != this.opt.length) {
			    store.setSingleGetPrices(false)
			    return
			}
			for(let i=0; i<this.opt.length; i++) {
			    if (price[i]!="0") {
				if (price[i]=="+0")
				    ;
				else if (price[i]=="×")
				    this.opt[i].price_diff = " ...<>"
				else if (price[i]=="Timeout") 
				    this.opt[i].price_diff = " ...<Timeout>"
				else
				    this.opt[i].price_diff = " ...<"+price[i]+"円>" 
			    } else
				this.opt[i].price_diff = ""
			}
			this.updated = true
			store.setSingleGetPrices(false)
		    },
		    error: (xhr,status,err) => {
			alert(err)
			store.setSingleGetPrices(false)
		    }
		}) */
		$.ajax({
		    url: '../../ValsInfo.action',
		    type: 'post',
		    async: false,
		    data: parameters,
		    dataType: "json",
		    success: (res) => {
			if(res.length < 1) {
			    store.setSingleGetPrices(false)
			    return
			}
			//console.log("res",res)
			//タイムアウト処理...
			if(res.timeout) {
			    console.log("timeout")
			    store.setSingleGetPrices(false)
			    this.$store.dispatch("rebuildSession").then(() => {
				this.infoUpdate()
			    })
			    return
			}

			// ↓ 金額計算が中断された場合
			if(res.length != this.opt.length) {
			    store.setSingleGetPrices(false)
			    return
			}
			let newOpt = []
			for(let i=0; i<this.opt.length; i++) {
			    if (res[i].diff!="0") {
				if (res[i].diff=="+0")
				    this.opt[i].price_diff = ""
				else if (res[i].diff=="×")
				    this.opt[i].price_diff = " ...<>"
				else if (res[i].diff=="Timeout") 
				    this.opt[i].price_diff = " ...<Timeout>"
				else
				    this.opt[i].price_diff = " ...<"+res[i].diff+"円>" 
			    } else
				this.opt[i].price_diff = ""
			    // this.opt[i].style = ""
			    this.opt[i].info = " "+res[i].info
			    //if(res[i].infoLevel > this.opt[i].infoLevel)
			    this.opt[i].infoLevel = res[i].infoLevel

			    /* if(this.opt[i].style == "") {
				    if(res[i].infoLevel == 1)
				    this.opt[i].style = "color: #FF0000;"
				    else
				    this.opt[i].style = "color: #FF8800;"
			     } */
			    // menuUpdateのメッセージをここで追加
			    //this.menuUpdate(this.opt[i])
			    // => checkPriceで処理するよう変更
			    
			    newOpt.push(this.opt[i])
			}
			this.opt = newOpt; //これをやらないと描画が更新されない
			this.updated = true
			store.setSingleGetPrices(false)
		    },
		    error: (xhr,status,err) => {
			console.log(err)
			store.setSingleGetPrices(false)
		    }
		})
	    //}
	},
	menuUpdates() {
	    let newOpt = []
	    for(let o of this.opt) {
		this.menuUpdate(o)
		newOpt.push(o)
	    }
	    this.opt = newOpt;
	}, 
	menuUpdate(o) {
	    o.message = ''
	    let mes = []
	    const result = this.$store.state.checkResult
	    if(!('menuUpdate' in result)) return
	    const ncode = o.value.split(/\s+/)
	    for(let u in result.menuUpdate) {
		if(u.match(/^bgColor:/)) continue;
		loop: for(let n of ncode)
		    for(let un of result.menuUpdate[u])
			if(n == un) {
			    //o.message += "u"
			    mes.push(u)
			    //o.style = "color: brown;"
			    break loop
			}
	    }
	    if(mes.length>0) o.message = "<<"+mes.join(" ")+">>"
	    // console.log(o.value, o.message)
	},
	changed(event) {
	    this.updated = false
	    store.setSingleGetPrices(false)
	    this.infoUpdate()
	    this.$emit('input', this.selected)

	    //this.$store.commit('update',{price: "126"})
	    //this.$store.dispatch('checkPrice')
	    if(this.$store.state.mdfLoad) {
		//タイムアウト発生後、selectIDが書き換えられている
		// => 画面描画完了後に金額更新
	    } else if("true" == this.custom) {
		//２段メニューの場合は、
		// ２段めの描画が完了してから価格計算する必要がある。
		this.$store.commit('customSelectChange',true)
		//this.$store.commit('setMdfLoad',true)
	    } else
		this.$store.dispatch('checkPrice')
	}
    },
    beforeMount() {
	const option = $(this.el).children()
	//console.debug(this.el.firstElementChild)
	this.opt = []
	for(let i=0; i<option.length; i++) {
	    //option[i].getAttribute('value')
	    let vals = {
		value: option[i].getAttribute('value'),
		text: $(option[i]).text(),
		price_diff: ''
	    }
	    if(option[i].hasAttribute('priceCode'))
		vals['priceCode'] = option[i].getAttribute('priceCode')
	    this.opt.push(vals)
	    
	    if(this.width < vals.text.length)
		this.width = vals.text.length

	    if((i==0)||option[i].hasAttribute('selected')) {
		this.selected = option[i].getAttribute('value')
		this.$emit('input', this.selected)
	    }
	}
	this.$store.commit('addSelect',this)
	// デフォルトで選択されている情報を更新 ... 時間がかかるので保留
	/*
	if("NULL"!=this.selected) {
	    let key = this.sel_name
	    let parameters = key+"="+this.selected
	    for (let o of this.opt) {
		if(o.value == this.selected) {
		    parameters += "&"+key+"="+o.value
		    if('priceCode' in o)
			parameters += "&priceCode="+o.priceCode
		    else
			parameters += "&priceCode=NULL"
		    break;
		}
	    }
	    parameters += "&key="+key
	    $.ajax({
		    url: '../../ValsInfo.action',
		    type: 'post',
		    async: false,
		    data: parameters,
		    success: (res) => {
			if(res.length < 1)
			    return
			//console.log(res)
			for(let i=0; i<this.opt.length; i++) {
			    if(this.selected == this.opt[i].value) {
				if(res[i].info != "")
				    this.opt[i].info = " "+res[i].info
				break;
			    }
			}
			//console.log(this.opt);
		    },
		    error: (xhr,status,err) => {
			console.log(err)
		    }
	    })
	} */
    },
    updated() {
	// console.log('s-select: updated');
    },
    components: {
    }
}
</script>



// WEBPACK FOOTER //
// SSelect.vue?b68749ec